// extracted by mini-css-extract-plugin
export var entityCardList = "styles-module--entityCardList--e696e";